var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.modules.account.user)?_c('div',{staticClass:"layout-wrapper d-lg-flex"},[_c('elSideMenu'),(_vm.$route.name != 'Dashboard')?_c('elLeftSidebar'):_vm._e(),_c('elChatContainer')],1):_c('elWelcome')
}
var staticRenderFns = []

export { render, staticRenderFns }